import React from 'react';

import { cn } from '~/utils/styles';

interface ChevronIconProps {
  className?: string;
  strokeColor?: string;
}

const ChevronIcon = ({ className, strokeColor = '#fff' }: ChevronIconProps): JSX.Element => (
  <svg className={cn('h-5 w-5', className)} viewBox="0 0 20 20" fill="none">
    <path
      d="m6,8l4,4l4,-4"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default ChevronIcon;
